/* eslint-disable react/forbid-dom-props */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Constants } from './../utils/constants';
import { generateTileClickPayloadAndLogTelemetry } from './../utils/detailUtils';
import { getComponentXYCoordinate } from './../utils/reactUtils';
import UserFavouriteTileButton from './../containers/userFavouriteTileButton';
import { DefaultButton, Stack, Text, mergeStyleSets } from '@fluentui/react';
import { useEffect, useRef } from 'react';
import { TelemetryImage } from './telemetryImage';
import { getNpsModule } from '@appsource/utils/nps';
import ProductsComponent from './products';
import { NeutralColors } from '@fluentui/theme';
import { getTooltipSilentLogIn } from '@shared/utils/silentLogInUtils';
import classNames from 'classnames';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { InternalLink } from '@shared/components/internalLink';
import { RatingsInfo } from './ratings/ratingsInfo';
import { useHydration } from '@shared/hooks/useHydration';
const pricingStyle = {
    root: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};
const contentStyle = mergeStyleSets({
    subText: [
        {
            color: NeutralColors.gray130,
            marginBottom: '5px'
        }
    ],
    startingPriceText: [
        {
            color: NeutralColors.gray160,
            'font-weight': 600
        }
    ],
    lightText: [
        {
            marginRight: '4px'
        }
    ],
    ctaButton: [
        {
            marginTop: '12px'
        }
    ],
    publisher: [
        {
            height: '48px'
        }
    ],
    linkesButton: [
        {
            background: 'none',
            border: 'none',
            padding: 0
        }
    ],
    tileContent: [
        {
            height: '320px'
        }
    ],
    embedTileContent: [
        {
            height: '380px'
        }
    ]
});
export const TileCTAbutton = ({ ctaData, isLoadingUserData, isEmbedded })=>{
    const [isCTAHover, setIsCTAHover] = React.useState(false);
    const { title, disabled, id, entityId, CtaType, area, view, onClick } = ctaData;
    const button = /*#__PURE__*/ _jsx(DefaultButton, {
        primary: isCTAHover,
        className: contentStyle.ctaButton,
        name: "button",
        type: "submit",
        text: title,
        disabled: disabled || isLoadingUserData && !isEmbedded,
        "data-bi-id": id,
        "data-bi-name": entityId,
        "data-bi-type": CtaType,
        "data-bi-area": area,
        "data-bi-view": view,
        onClick: (e)=>{
            e.preventDefault();
            return onClick(e);
        },
        onKeyDown: (e)=>{
            if (e.charCode === Constants.SystemKey.Enter) {
                onClick();
            }
        },
        onMouseEnter: ()=>setIsCTAHover(true),
        onMouseLeave: ()=>setIsCTAHover(false)
    });
    return getTooltipSilentLogIn(button, isLoadingUserData);
};
const TileFooter = ({ isEmbedded, isLoadingUserData, onKeyDown, ctaData, price, popularity, onClick, rating, context, userFavouriteEntityType, id, item })=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        verticalAlign: "end",
        className: "tileFooterBox",
        tokens: {
            childrenGap: 2
        },
        children: [
            rating && /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(RatingsInfo, {
                    avgRating: rating.avgRating,
                    ratingsCount: rating.ratingsCount,
                    title: rating.text,
                    context: context,
                    textSize: 'smallPlus'
                }, rating.key)
            }),
            price && /*#__PURE__*/ _jsx(Stack.Item, {
                children: /*#__PURE__*/ _jsx(Stack, {
                    horizontal: true,
                    tokens: {
                        childrenGap: 2
                    },
                    children: /*#__PURE__*/ _jsx(Stack.Item, {
                        shrink: 1,
                        styles: pricingStyle,
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: 'small',
                            className: `${contentStyle.startingPriceText}`,
                            children: price
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                verticalAlign: "baseline",
                tokens: {
                    childrenGap: 5
                },
                children: [
                    ctaData && /*#__PURE__*/ _jsx(TileCTAbutton, {
                        onKeyDown: onKeyDown,
                        isLoadingUserData: isLoadingUserData,
                        ctaData: ctaData,
                        isEmbedded: isEmbedded
                    }),
                    userFavouriteEntityType && /*#__PURE__*/ _jsx(UserFavouriteTileButton, {
                        entityId: id,
                        entityType: userFavouriteEntityType,
                        item: item
                    })
                ]
            }),
            popularity && /*#__PURE__*/ _jsxs(Text, {
                children: [
                    "P#: ",
                    popularity * 1000 || 'none'
                ]
            })
        ]
    });
};
export const BaseTile = ({ id, item, iconURL, title, tileDataRequestId, publisher, description, ctaData, detailUrl, tileIndex, componentInstance, userFavouriteEntityType, currentView, linkedAddIns, linkedWebApps, price, rating, badge, onOpenTile, products, totalTiles, context, isLoadingUserData, popularity, count, activeFilters, searchSortingBy, searchReqId, shouldShowLinkedAddIn, shouldShowLinkedWebApps, badgeTypes, ribbonKey = '', isEmbedded })=>{
    const index = tileIndex + 1;
    const tileId = `${componentInstance}-${id.replace('.', '-')}_${index}`;
    const [imgUrlError, setImgUrlError] = React.useState(false);
    const isHydrated = useHydration();
    useEffect(()=>{
        setImgUrlError(true);
    }, []);
    const ref = useRef(null);
    const logOnClick = ()=>{
        const reference = ref.current;
        const coordinate = getComponentXYCoordinate(reference);
        const details = {
            id,
            rank: {
                rank: tileIndex + 1,
                total: totalTiles
            },
            xOffset: coordinate.x,
            yOffset: coordinate.y,
            currentView,
            tileDataRequestId,
            discoveryData: {
                totalNumOfResults: count,
                activeFilters,
                sortingBy: searchSortingBy,
                searchRequestId: searchReqId
            },
            badges: JSON.stringify(badgeTypes),
            ribbonKey,
            publisherId: item.publisherId,
            appName: item.entityId
        };
        // Add Legacy Telemetry Properties for Bundle Tile Click
        if (shouldShowLinkedAddIn || shouldShowLinkedWebApps) {
            details.isSaaSBundle = true;
        }
        generateTileClickPayloadAndLogTelemetry(Constants.Telemetry.ActionModifier.Tile, details);
    };
    const handleTileClick = (event)=>{
        onOpenTile === null || onOpenTile === void 0 ? void 0 : onOpenTile(event);
        logOnClick();
    };
    const handleTileKeyDown = (event)=>{
        if (event.key === Constants.SystemKeyString.Enter) {
            handleTileClick(event);
        }
    };
    const preventNavigation = (e)=>{
        e.preventDefault();
        e.stopPropagation();
    };
    const descriptionclassNames = classNames({
        multineEllipsis: true,
        description: !linkedAddIns,
        mobileDescription: true
    });
    const oneTimePaymentOffer = isOneTimePaymentOffer(id);
    return /*#__PURE__*/ _jsx(InternalLink, {
        "data-testid": `tile-link-container`,
        title: title,
        className: "tileContainer",
        href: detailUrl,
        ref: ref,
        role: "link",
        "aria-labelledby": `label-${tileId} labelBy-${tileId}`,
        "aria-describedby": `desc-${tileId} descPrice-${tileId} descCompetency-${tileId}`,
        "data-bi-name": id,
        "data-bi-area": linkedAddIns && currentView === Constants.currentView.AppDetails ? Constants.Telemetry.AreaName.ParentSaaSTile : Constants.Telemetry.AreaName.AppTile,
        "data-bi-view": Constants.Telemetry.TemplateName.SaaSBundle,
        accEnabled: true,
        onKeyDown: handleTileKeyDown,
        children: /*#__PURE__*/ _jsxs(Stack, {
            verticalAlign: "space-between",
            className: "tileContent ms-depth-8",
            onClick: (e)=>{
                var _getNpsModule;
                handleTileClick(e);
                (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter('pdpViewsCount');
            },
            children: [
                badge,
                /*#__PURE__*/ _jsxs(Stack, {
                    tokens: {
                        childrenGap: 8
                    },
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: 'tileIcon ms-depth-8',
                            children: iconURL && imgUrlError && /*#__PURE__*/ _jsx(TelemetryImage, {
                                src: iconURL,
                                alt: `${title} icon`,
                                onError: ()=>setImgUrlError(false),
                                itemPropName: 'tileImage'
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            className: 'tileHeaderBox',
                            tokens: {
                                childrenGap: 8
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    variant: 'large',
                                    nowrap: true,
                                    block: true,
                                    className: `${contentStyle.publisher} title multineEllipsis ms-fontWeight-semibold`,
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    variant: 'small',
                                    className: `${contentStyle.subText} publisher`,
                                    children: publisher
                                }),
                                !oneTimePaymentOffer && !!(products === null || products === void 0 ? void 0 : products.length) && /*#__PURE__*/ _jsx(ProductsComponent, {
                                    textSize: 'smallPlus',
                                    withTooltip: true,
                                    tooltipTitle: 'Applicable to:',
                                    withText: true,
                                    productsItems: products,
                                    linkedAddIns: linkedAddIns,
                                    linkedWebApps: linkedWebApps
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    variant: 'small',
                                    className: `${contentStyle.subText} ${descriptionclassNames} `,
                                    children: description
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    id: `labelIndexString-${tileId}`,
                                    className: "totalTiles",
                                    children: `${index} out of ${totalTiles}`
                                })
                            ]
                        })
                    ]
                }),
                isHydrated && /*#__PURE__*/ _jsx(TileFooter, {
                    onClick: preventNavigation,
                    onKeyDown: handleTileKeyDown,
                    isEmbedded: isEmbedded,
                    isLoadingUserData: isLoadingUserData,
                    item: item,
                    userFavouriteEntityType: userFavouriteEntityType,
                    ctaData: ctaData,
                    id: id,
                    price: price,
                    popularity: popularity,
                    rating: rating,
                    context: context
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobileUserFavourite",
                    onClick: preventNavigation,
                    children: userFavouriteEntityType && /*#__PURE__*/ _jsx(UserFavouriteTileButton, {
                        entityId: id,
                        entityType: userFavouriteEntityType,
                        item: item
                    })
                })
            ]
        })
    });
};
